import { Badge, Button, Form, FormGroup, Input, Label } from "reactstrap";
import { COUNTRIES } from "../utils/Constants";
import { useEffect, useState } from "react";

interface Props {
  representativeEmail: string;
  companyNameJapanese: string;
  companyNameEnglish: string;
  companyNumber: string;
  companyLocation: string;
  companyLocationOther: string;
  companyState: string;
  companyAddress: string;
  handleChange: (event: any) => void;
  handleNext: (event: any) => void;
  handlePrevious: (event: any) => void;
}

// MemberAccountForm
export const StepFive: React.FC<Props> = ({ representativeEmail, companyNameJapanese, companyNameEnglish, companyNumber, companyLocation, companyLocationOther, companyState, companyAddress, handleChange, handleNext, handlePrevious }) => {

  const [valid, setValid] = useState(false);

  useEffect(() => {
    const valid = (() => {
      return !!representativeEmail && !!companyNameJapanese && !!companyNameEnglish && !!companyNumber && !!companyState && !!companyLocation && !!companyAddress;
    })();
    setValid(valid);
    // eslint-disable-next-line
  }, [
    representativeEmail,
    companyNameJapanese,
    companyNameEnglish,
    companyNumber,
    companyLocation,
    companyState,
    companyAddress
  ]);

	return (
		<>
			<h2 className='pt-5 pb-3 font-weight-bold'><strong>入会お申込みフォーム / Membership Application Form</strong></h2>
      <h3 style={{ fontSize: '16px', color: '#808080' }} className="pb-3">以下に貴社の情報をご入力ください。</h3>
      <Badge style={{ fontSize: "14px" }} color="info">会社情報の入力</Badge>

      <Form className='pt-4'>
        <Label>会社名【日本語】/ Company Name (Japanese)<span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup>
          <Input
            id="companyNameJapanese"
            name="companyNameJapanese"
            type="text"
            value={companyNameJapanese}
            onChange={handleChange}
          />
        </FormGroup>
      </Form>
  
      <Form className='pt-5'>
        <Label>会社名【英語】/ Company Name (English)<span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup>
          <Input
            id="companyNameEnglish"
            name="companyNameEnglish"
            type="text"
            value={companyNameEnglish}
            onChange={handleChange}
          />
        </FormGroup>
      </Form>

      <Form className='pt-5'>
        <Label>会社登記番号 / Company Registration Number<span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup>
          <Input
            id="companyNumber"
            name="companyNumber"
            type="text"
            value={companyNumber}
            onChange={handleChange}
          />
        </FormGroup>
      </Form>

      <Form className='pt-5'>
        <Label>所在国 / Country <span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup>
          <Input
            id="companyLocation"
            name="companyLocation"
            type="select"
            value={companyLocation}
            onChange={handleChange}
          >
            {
              COUNTRIES.map(country => (
                <option key={country.value} value={country.value}>{country.label}</option>
              ))
            }
          </Input>
        </FormGroup>
      </Form>

      {(companyLocation === "Other") && (
        <Form className='pt-5'>
          <Label>所在国 (その他) / Country (Other) <span style={{ color: "red" }}> (*)</span></Label>
          <FormGroup>
            <Input
              id="companyLocationOther"
              name="companyLocationOther"
              type="text"
              value={companyLocationOther}
              onChange={handleChange}
            />
          </FormGroup>
        </Form>
      )}

      <Form className='pt-5'>
        <Label>州 / State <span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup>
          <Input
            id="companyState"
            name="companyState"
            type="text"
            value={companyState}
            onChange={handleChange}
          />
        </FormGroup>
      </Form>

      <Form className='pt-5'>
        <Label>会社所在地 / Company Address<span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup>
          <Input
            id="companyAddress"
            name="companyAddress"
            type="textarea"
            rows="5"
            value={companyAddress}
            onChange={handleChange}
          />
        </FormGroup>
      </Form>

			<Form className='pt-5'>
				<Label>ご担当者様メールアドレス / Email Address<span style={{ color: "red" }}> (*)</span></Label>
				<FormGroup>
					<Input
						id="representativeEmail"
						name="representativeEmail"
						type="email"
            value={representativeEmail}
						onChange={handleChange}
					/>
				</FormGroup>
			</Form>

			<div className='justify-content-end pt-5 d-flex gap-3'>
        <Button 
          color="secondary" 
          outline
          onClick={handlePrevious}
          >戻る / Previous
        </Button>
				<Button 
					color="info" 
					outline
          disabled={!valid}
          onClick={handleNext}
					>次へ / Next
				</Button>
			</div>
		</>
	)
}

export default StepFive;